import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { env, envPython } from 'src/environments/environments';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentVariablesService {

  private readonly fastapi_url_base = `${envPython.url_base}`;
  
  constructor(private http: HttpClient) { }

  loadConfig(): Observable<{success: boolean; message: string; data?: any; }> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .post<{
        success: boolean;
        message: string;
        data: any;
      }>(`${this.fastapi_url_base}/variablesEntorno`, { headers })
      .pipe(
        map((response: any) => {
          if (response.success) {
            return {
              success: true,
              message: 'Variables de entorno encontrados',
              data: response.data
            };
          } else {
            return {
              success: false,
              message: 'No hay variables de entorno',
              data: []
            };
          }
        }),
        catchError((error) => {
          console.error('API error:', error);
          return of({ success: false, message: error.message, data: [] });
        })
      );
  }
}
